import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { LocationProps } from '../api/response';
// const Province = require('./province.json');

export const useLocationMutation = () => {
  // const [data, setData] = useState([]);
  // const [isLoading, setLoading] = useState(true);

  // useEffect(() => {
  //   handleFakeFetch();
  // }, []);

  // const handleFakeFetch = async () => {
  //   setTimeout(() => {
  //     setData(Province.data);
  //     setLoading(false);
  //   }, 500);
  // };
  const axios = useAxios();

  const handleFetchLocations = ({
    fromLocationId,
    toLocationId,
  }: {
    fromLocationId?: string;
    toLocationId?: string;
  }) => {
    console.log({ fromLocationId, toLocationId });
    let params = {};
    if (fromLocationId) {
      params = {
        from_location_id: fromLocationId,
      };
    }
    if (toLocationId) {
      params = {
        to_location_id: toLocationId,
      };
    }
    return axios.get<AxiosResponse<LocationProps[]>>(ApiRoutes.locations, {
      params,
    });
  };

  return useMutation(['locations'], handleFetchLocations, {
    // select: res => res.data.data,
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
    // staleTime: USE_QUERY_CONSTANTS.staleMs,
    retry: USE_QUERY_CONSTANTS.retry,
    // enabled: false,
  });
  // return {
  //   data,
  //   isLoading,
  // };
};
